import { render, staticRenderFns } from "./MobileNotification.vue?vue&type=template&id=268f9bca&scoped=true&"
import script from "./MobileNotification.vue?vue&type=script&lang=js&"
export * from "./MobileNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268f9bca",
  null
  
)

export default component.exports